import { render, staticRenderFns } from "./DetalleLinea.vue?vue&type=template&id=6a93b28e&"
import script from "./DetalleLinea.vue?vue&type=script&lang=js&"
export * from "./DetalleLinea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports